import {UserPreferences} from './user-preferences';
import {MarkerType} from './enums';
import {Helper} from './helper';
import {Listing} from './listing';
import LatLngLiteral = google.maps.LatLngLiteral;

export class RemaxMarker {
  lat: number;
  lng: number;
  label?: string;
  fullPrice?: number;
  isPricePerSqft?: boolean;
  isCluster?: boolean;
  iconType: string;
  markerType: MarkerType;
  hasBeenViewed?: boolean = false;
  isFavourite: boolean = false;
  isMyLocation: boolean = false;

  constructor() {  }

  static generateListingMarkerFromListing(text: string, listing: Listing, favouriteListings?: string[], viewedListings?: string[]): RemaxMarker {
    const marker = new RemaxMarker();
    marker.lng = <number>listing.lng;
    marker.lat = <number>listing.lat;
    marker.isCluster = false;
    marker.hasBeenViewed = UserPreferences.containsPreviouslyViewedListings(viewedListings || [], []);
    marker.isFavourite = UserPreferences.containsFavouriteListings(favouriteListings || [], []);
    marker.label = text;
    return marker;
  }

static generatePlainMarker(isMyLocation: boolean = false, isOffice: boolean = false, latLng?: LatLngLiteral): RemaxMarker {
  const marker = new RemaxMarker();
    if (isOffice) marker.markerType = MarkerType.OFFICE;
    else marker.markerType = MarkerType.PLAIN;
    marker.iconType = Helper.getStaticPathForResource('assets/map-pins/office-pin.png');
    marker.isMyLocation = isMyLocation;
    if (latLng) {
      marker.lat = latLng.lat;
      marker.lng = latLng.lng;
    }
    return marker;
  }
}
